import PropTypes from "prop-types";
import React from "react";
import {
  Carousel as BCarousel,
  CarouselItem as BCarouselItem,
} from "react-bootstrap";

class Carousel extends React.Component {
  static get displayName() {
    return "Carousel";
  }

  static get propTypes() {
    return {
      items: PropTypes.arrayOf(PropTypes.string),
    };
  }

  static get defaultProps() {
    return {
      items: [],
    };
  }

  render() {
    return <BCarousel>{this._renderItems()}</BCarousel>;
  }

  _renderItems() {
    let items = [];
    for (let item of this.props.items) {
      items.push(
        <BCarouselItem key={item}>
          <img width="100%" src={item} />
        </BCarouselItem>,
      );
    }
    return items;
  }
}

module.exports = Carousel;
